<template>
  <div>
    <el-select
      v-model="operateData"
      :placeholder="$t('pc.trading.please_select_an_account')"
      style="width: 100%"
      @change="changeOperate"
    >
      <el-option
        v-for="item in operateOptions"
        :key="item.cid"
        :label="item.name + '(' + item.order + ')' + $t('pc.trading.balance')+':' + item.use"
        :value="item.cid"
      >
      </el-option>
    </el-select>
    <el-tabs
      type="border-card"
      stretch
      v-model="tabsName"
      @tab-click="handleClick"
    >
      <el-tab-pane :label="$t('pc.trading.short_sell')" name="sellStock">
        <el-row :gutter="10" style="height: 560px;">
          <el-col :span="14">
            <el-form :model="stockSell" size="medium">
              <el-form-item style="margin-bottom: 10px;">
                <el-select
                  v-model="stockSell.info"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                  :loading="loading"
                  :placeholder="$t('pc.allhkstock.code_name_abbreviation')"
                  @change="changeInfo('sell', true)"
                  size="small"
                  class="full_width"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.short"
                    :label="item.name + ' ' + item.code_new"
                    :value="item.short"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-row>
                  <el-col :span="8">
                    <el-button
                      type="success"
                      @click="changePrice('sell')"
                      v-if="changeSellType"
                      size="small"
                      class="full_width button_green_color"
                      >{{ $t('pc.trading.market_price') }}</el-button
                    >
                    <el-button
                      type="success"
                      @click="changePrice('sell')"
                      v-else
                      size="small"
                      class="full_width button_green_color"
                      >{{ $t('pc.trading.limit_price') }}</el-button
                    >
                  </el-col>
                  <el-col :span="16">
                    <el-input
                      v-if="changeSellType"
                      :disabled="true"
                      size="small"
                      class="full_width"
                      :placeholder="$t('pc.trading.market_sell')"
                    ></el-input>
                    <el-input
                      v-model="stockSell.limitPrice"
                      v-else
                      size="small"
                      class="full_width"
                      :placeholder="$t('pc.trading.sell_price')"
                    ></el-input>
                  </el-col>
                </el-row>
                <!-- <p>
                  涨停价:<span class="red">{{ stockSell.hardenPrice }}</span
                  >&nbsp;&nbsp;&nbsp;跌停价:<span class="red">{{
                    stockSell.dropPrice
                  }}</span>
                </p> -->
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-input
                  v-model="stockSell.number"
                  size="small"
                  :placeholder="$t('pc.trading.sell_volume')"
                ></el-input>
                <el-row> 
                  <el-col :span="12">
                    <p v-if="changeSellType">
                      {{ $t('pc.trading.available_for_sale') }}<span class="green"> {{ sellMarketPrice }} </span
                      >{{ $t('pc.trading.shares') }}
                    </p>
                    <p v-else>
                      {{ $t('pc.trading.available_for_sale') }}<span class="green"> {{ sellLimitPrice }} </span
                    >{{ $t('pc.trading.shares') }}
                    </p>
                  </el-col>
                  <!-- <el-col :span="12" style="text-align:right;">
                    <p>
                      每手股数<span class="red">{{ handsVolume }}</span
                      >
                    </p>
                  </el-col> -->
                </el-row>

              </el-form-item>
              <el-form-item>
                <el-row>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('sellFull')"
                      >{{ $t('pc.trading.full_position') }}</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('sellThreeFourths')"
                      >3/4</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('sellTwoFourths')"
                      >1/2</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('sellOneFourths')"
                      >1/4</el-button
                    >
                  </el-col>
                </el-row>
              </el-form-item>
              <!-- <el-form-item label-width="0">
                <el-button type="primary submit" size="small" @click="sellStock"
                  >卖出</el-button
                >
              </el-form-item> -->
            </el-form>
          </el-col>
          <el-col :span="10">
            <el-card id="cardPaddingSell" class="box-card" shadow="never">
              <el-row>
                <el-col :span="24">
                  <p style="font-size: 12px;text-align: center;padding: 0px 10px 17px;">{{ $t('pc.trading.market') }}</p>
                </el-col>
              </el-row>
              <el-row>
                <div
                  class="center box-market"
                  v-for="(item, index) in stockSell.sellArr"
                  :key="index"
                >
                  <el-col :span="8">{{ $t(item.id) }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </div>
              </el-row>
              <el-row style="padding-top: 15px;">
                <p
                  class="center box-market"
                  v-for="(item, index) in stockSell.buyArr"
                  :key="index"
                >
                  <el-col :span="8">{{ $t(item.id) }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </p>
              </el-row>
            </el-card>
            <!-- <el-card class="box-card" shadow="never" style="margin-top: 10px">
              <el-row>
                <p
                  class="center box-market"
                  v-for="(item, index) in stockSell.buyArr"
                  :key="index"
                >
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </p>
              </el-row>
            </el-card> -->
            <el-row style="padding-top: 31px;">
              <el-col :span="24">
                <el-form label-width="0" size="medium">
                  <el-form-item label-width="0">
                    <el-button type="primary submit" size="small" @click="sellStock" class="button_green_color"
                      >{{ $t('pc.trading.short_selling') }}</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-table
              :data="holdData"
              stripe
              height="340px"
              @row-click="sellHanddle"
              size="small"
              style="width: 100%"
              :empty-text="$t('pc.table.no_data')"
            >
              <el-table-column :label="$t('pc.allhkstock.name')+'/'+$t('pc.trading.market_value')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.name }}</p>
                    <p class="green">{{ scope.row.market }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.name }}</p>
                    <p class="red">{{ scope.row.market }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.position')+'/'+$t('pc.trading.available')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.number }}</p>
                    <p class="green">{{ scope.row.sellable }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.number }}</p>
                    <p class="red">{{ scope.row.sellable }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.current_price')+'/'+$t('pc.trading.average_price')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.priceRatio.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.newPrice }}</p>
                    <p class="green">{{ scope.row.price }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.newPrice }}</p>
                    <p class="red">{{ scope.row.price }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.total_profit_and_loss')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.profitMarket }}</p>
                    <p class="green">{{ scope.row.priceRatio }}%</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.profitMarket }}</p>
                    <p class="red">{{ scope.row.priceRatio }}%</p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane :label="$t('pc.trading.close_short_position')" name="buyStock">
        <el-row :gutter="10" style="height: 560px;">
          <el-col :span="14">
            <el-form label-width="0" :model="stockBuy" size="medium">
              <el-form-item style="margin-bottom: 10px">
                <el-select
                  v-model="stockBuy.info"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                  :loading="loading"
                  :placeholder="$t('pc.allhkstock.code_name_abbreviation')"
                  @change="changeInfo('buy', true)"
                  size="small"
                  class="full_width"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.short"
                    :label="item.name + ' ' + item.code_new"
                    :value="item.short"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-row>
                  <el-col :span="8">
                    <el-button
                      type="primary"
                      @click="changePrice('buy')"
                      v-if="changeBuyType"
                      size="small"
                      class="full_width  button_blue_color"
                      >{{ $t('pc.trading.market_price') }}</el-button
                    >
                    <el-button
                      type="primary"
                      @click="changePrice('buy')"
                      v-else
                      size="small"
                      class="full_width button_blue_color"
                      >{{ $t('pc.trading.limit_price') }}</el-button
                    >
                  </el-col>
                  <el-col :span="16">
                    <el-input
                      :disabled="true"
                      v-if="changeBuyType"
                      size="small"
                      class="full_width"
                      :placeholder="$t('pc.trading.market_buy')"
                    ></el-input>
                    <el-input
                      v-model="stockBuy.limitPrice"
                      v-else
                      size="small"
                      class="full_width"
                      :placeholder="$t('pc.trading.buy_price')"
                    ></el-input>
                  </el-col>
                </el-row>
                <!-- <p>
                  涨停价:<span class="red">--</span
                  >&nbsp;&nbsp;&nbsp;跌停价:<span class="red">--</span>
                </p> -->
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-input
                  v-model="stockBuy.number"
                  size="small"
                  type="number"
                  :placeholder="$t('pc.trading.buy_volume')"
                ></el-input>
                <el-row> 
                  <el-col :span="12">
                    <p>
                      {{ $t('pc.trading.can_be_purchase') }}<span class="blue"> {{ parseInt(stockBuy.validNumber) }} </span
                      >{{ $t('pc.trading.shares') }}
                    </p>
                  </el-col>
                  <!-- <el-col :span="12" style="text-align:right;">
                    <p>
                      每手股数<span class="red">{{ handsVolume }}</span
                      >
                    </p>
                  </el-col> -->
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-row>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('buyFull')"
                      >{{ $t('pc.trading.full_position') }}</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('buyThreeFourths')"
                      >3/4</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('buyTwoFourths')"
                      >1/2</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('buyOneFourths')"
                      >1/4</el-button
                    >
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="10">
            <el-card id="cardPadding" class="box-card" shadow="never">
              <el-row>
                <el-col :span="24">
                  <p style="font-size: 12px;text-align: center;padding: 0px 10px 17px;">{{ $t('pc.trading.market') }}</p>
                </el-col>
              </el-row>
              <el-row>
                <div
                  class="center box-market"
                  v-for="(item, index) in stockBuy.sellArr"
                  :key="index"
                >
                  <el-col :span="8">
                    <span>{{ $t(item.id) }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span v-if="item.price == 0">--</span>
                    <span v-else>{{ item.price }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span v-if="item.number == 0">--</span>
                    <span v-else>{{ item.number }}</span>
                  </el-col>
                </div>
              </el-row>
              <el-row style="padding-top: 15px;">
                <p
                  class="center box-market"
                  v-for="(item, index) in stockBuy.buyArr"
                  :key="index"
                >
                  <el-col :span="8">
                    <span>{{ $t(item.id) }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span v-if="item.price == 0">--</span>
                    <span v-else>{{ item.price }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span v-if="item.number == 0">--</span>
                    <span v-else>{{ item.number }}</span>
                  </el-col>
                </p>
              </el-row>
            </el-card>
            <!-- <el-card class="box-card" shadow="never" style="margin-top: 10px">
              <el-row>
                <p
                  class="center box-market"
                  v-for="(item, index) in stockBuy.buyArr"
                  :key="index"
                >
                  <el-col :span="8">
                    <span>{{ item.id }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span v-if="item.price == 0">--</span>
                    <span v-else>{{ item.price }}</span>
                  </el-col>
                  <el-col :span="8">
                    <span v-if="item.number == 0">--</span>
                    <span v-else>{{ item.number }}</span>
                  </el-col>
                </p>
              </el-row>
            </el-card> -->
            <el-row style="padding-top: 31px;">
              <el-col :span="24">
                <el-form label-width="0" size="medium">
                  <el-form-item label-width="0">
                    <el-button type="danger submit" size="small" @click="buyStock" class="button_blue_color"
                      >{{ $t('pc.trading.short_sell_close_position') }}</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-table
              :data="holdData"
              stripe
              height="340px"
              @row-click="buyHanddle"
              size="small"
              style="width: 100%"
              :empty-text="$t('pc.table.no_data')"
            >
              <el-table-column :label="$t('pc.allhkstock.name')+'/'+$t('pc.trading.market_value')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.name }}</p>
                    <p class="green">{{ scope.row.market }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.name }}</p>
                    <p class="red">{{ scope.row.market }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.position')+'/'+$t('pc.trading.available')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.number }}</p>
                    <p class="green">{{ scope.row.sellable }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.number }}</p>
                    <p class="red">{{ scope.row.sellable }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.current_price')+'/'+$t('pc.trading.average_price')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.newPrice }}</p>
                    <p class="green">{{ scope.row.price }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.newPrice }}</p>
                    <p class="red">{{ scope.row.price }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.total_profit_and_loss')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.profitMarket }}</p>
                    <p class="green">{{ scope.row.priceRatio }}%</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.profitMarket }}</p>
                    <p class="red">{{ scope.row.priceRatio }}%</p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane :label="$t('pc.trading.cancel_order')" name="canceStock">
        <el-table
          :data="cancelData"
          height="560px"
          size="small"
          stripe
          style="width: 100%"
          :empty-text="$t('pc.table.no_data')"
        >
          <el-table-column :label="$t('pc.trading.stock')+'/'+$t('pc.trading.time')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.name }}</p>
              <p style="font-size: 13px;">{{ $getDeviceTime(scope.row.time) }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pc.trading.entrustment_price')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.deal }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pc.trading.entrustment')+'/'+$t('pc.trading.transaction')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.number }}</p>
              <p>{{ scope.row.finish }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pc.trading.business')+'/'+$t('pc.trading.status')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.type }}</p>
              <p>{{ scope.row.status }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pc.trading.operate')" align="center">
            <template slot-scope="scope">
              <el-button
                class="extra-mini-btn"
                type="danger"
                @click="handleCance(scope.row)"
                >{{ $t('pc.trading.cancel_order') }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('pc.trading.position')" name="holdStock">
        <el-table
          height="560px"
          size="small"
          :data="holdData"
          stripe
          style="width: 100%"
          :empty-text="$t('pc.table.no_data')"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-row>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      size="small"
                      @click="holdBuy(props.row.short,props.row.code)"
                      >{{ $t('pc.trading.buy') }}</el-button
                    >
                  </el-col>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      size="small"
                      @click="holdSell(props.row.short,props.row.code)"
                      >{{ $t('pc.trading.sell') }}</el-button
                    >
                  </el-col>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      size="small"
                      @click="marketGo(props.row.short)"
                      >{{ $t('pc.trading.market') }}</el-button
                    >
                  </el-col>
                </el-row>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pc.allhkstock.name')+'/'+$t('pc.trading.direction')">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.name }}</p>
                <p class="green">{{ scope.row.direction }}</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.name }}</p>
                <p class="red">{{ scope.row.direction }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pc.trading.position')+'/'+$t('pc.trading.available')">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.number }}</p>
                <p class="green">{{ scope.row.sellable }}</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.number }}</p>
                <p class="red">{{ scope.row.sellable }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pc.trading.current_price')+'/'+$t('pc.trading.average_price')">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.newPrice }}</p>
                <p class="green">{{ scope.row.price }}</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.newPrice }}</p>
                <p class="red">{{ scope.row.price }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pc.trading.market_value')+'/'+$t('pc.trading.total_profit_and_loss')">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.market }}</p>
                <p class="green" style="font-size: 10px;">{{ scope.row.profitMarket }}({{ scope.row.priceRatio }}%)</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.market }}</p>
                <p class="red" style="font-size: 10px;">{{ scope.row.profitMarket }}({{ scope.row.priceRatio }}%)</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('pc.trading.query')">
        <el-tabs stretch>
          <el-tab-pane :label="$t('pc.trading.entrusted_query')">
            <el-table
              size="small"
              height="505px"
              :data="entrustData"
              stripe
              style="width: 100%"
              :empty-text="$t('pc.table.no_data')"
            >
              <el-table-column :label="$t('pc.trading.date')+'/'+$t('pc.trading.time')" align="center">
                <template slot-scope="scope">
                  <p style="font-size: 11px;">{{ $getDeviceTime(scope.row.time) }}</p>
                  <!-- <p>{{ scope.row.accurate }}&nbsp;</p> -->
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.allhkstock.name')+'/'+$t('pc.allhkstock.code')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.direction')+'/'+$t('pc.trading.business')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.direction }}</p>
                  <p>{{ scope.row.trade_type }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.type')+'/'+$t('pc.trading.status')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.order_type }}</p>
                  <p>{{ scope.row.status }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.entrustment')+'/'+$t('pc.trading.transaction_price')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.deal }}&nbsp;</p>
                  <p>{{ scope.row.price }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.entrustment')+'/'+$t('pc.trading.trading_volume')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.number }}&nbsp;</p>
                  <p>{{ scope.row.finish }}&nbsp;</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="$t('pc.trading.transactional_records')">
            <el-table
              size="small"
              height="505px"
              :data="dealData"
              stripe
              style="width: 100%"
              :empty-text="$t('pc.table.no_data')"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="right" size="mini">
                    <el-form-item :label="$t('pc.trading.date_time')">
                      <p class="right">
                        {{ $getDeviceTime(props.row.time) }} 
                        <!-- {{ props.row.accurate }} -->
                      </p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.business_name')">
                      <p class="right">{{ props.row.type }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.stock_code')">
                      <p class="right">
                        {{ props.row.name }} {{ props.row.code }}
                      </p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.transaction_quantity')">
                      <p class="right">{{ props.row.number }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.transaction_sold_price')">
                      <p class="right">{{ props.row.price }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.transaction_amount')">
                      <p class="right">{{ props.row.total }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.broker_commission')">
                      <p class="right">{{ props.row.commission }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.transfer_fee')">
                      <p class="right">{{ props.row.change }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.stamp_duty')">
                      <p class="right">{{ props.row.stamp }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.product_handling_fee')">
                      <p class="right">{{ props.row.extra_fee1 }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.settlement_costs')">
                      <p class="right">{{ props.row.extra_fee2 }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.platform_fees')">
                      <p class="right">{{ props.row.extra_fee3 }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.trading_activity_fee')">
                      <p class="right">{{ props.row.transaction }}</p>
                    </el-form-item>
                     <el-form-item :label="$t('pc.trading.frc_transaction')">
                      <p class="right">{{ props.row.chj_levy }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.lump_sum')">
                      <p class="right">{{ props.row.totalplus }}</p>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.date')+'/'+$t('pc.trading.time')" align="center">
                <template slot-scope="scope">
                  <p style="font-size: 11px;">{{ $getDeviceTime(scope.row.time) }}</p>
                  <!-- <p>{{ scope.row.accurate }}</p> -->
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.allhkstock.name')+'/'+$t('pc.allhkstock.code')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.direction')+'/'+$t('pc.trading.business')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.direction }}</p>
                  <p>{{ scope.row.trade_type }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.order')+'/'+$t('pc.trading.quantity')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.order_type }}</p>
                  <p>{{ scope.row.number }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.unit_price')+'/'+$t('pc.trading.total_price')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.price }}</p>
                  <p>{{ scope.row.total }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="$t('pc.trading.system_closing_possition')">
            <el-table
              size="small"
              height="505px"
              :data="unwindData"
              stripe
              style="width: 100%"
              :empty-text="$t('pc.table.no_data')"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="right" size="mini">
                    <el-form-item :label="$t('pc.trading.date_time')">
                      <p class="right">
                        {{ $getDeviceTime(props.row.time) }} 
                        <!-- {{ props.row.accurate }} -->
                      </p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.business_name')">
                      <p class="right">{{ props.row.type }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.stock_code')">
                      <p class="right">
                        {{ props.row.name }} {{ props.row.code }}
                      </p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.transaction_quantity')">
                      <p class="right">{{ props.row.number }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.transaction_sold_price')">
                      <p class="right">{{ props.row.price }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.broker_commission')">
                      <p class="right">{{ props.row.commission }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.transfer_fee')">
                      <p class="right">{{ props.row.change }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.stamp_duty')">
                      <p class="right">{{ props.row.stamp }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('pc.trading.lump_sum')">
                      <p class="right">{{ props.row.total }}</p>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.date')+'/'+$t('pc.trading.time')" align="center">
                <template slot-scope="scope">
                  <p style="font-size: 11px;">{{ $getDeviceTime(scope.row.time) }}</p>
                  <!-- <p>{{ scope.row.accurate }}</p> -->
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.allhkstock.name')+'/'+$t('pc.allhkstock.code')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.direction')+'/'+$t('pc.trading.business')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.direction }}</p>
                  <p>{{ scope.row.trade_type }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.order')+'/'+$t('pc.trading.quantity')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.order_type }}</p>
                  <p>{{ scope.row.number }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.unit_price')+'/'+$t('pc.trading.total_price')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.price }}</p>
                  <p>{{ scope.row.total }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="$t('pc.trading.statement')">
            <el-table
              height="505px"
              size="small"
              :data="capitalData"
              stripe
              style="width: 100%"
              :empty-text="$t('pc.table.no_data')"
            >
              <el-table-column :label="$t('pc.trading.date')" align="center">
                <template slot-scope="scope">
                  <p>{{ $getDeviceTime(scope.row.time) }}</p>
                  <!-- <p>{{ scope.row.accurate }}</p> -->
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.allhkstock.name')+'/'+$t('pc.trading.type')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.type }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('pc.trading.amount')+'/'+$t('pc.trading.balance')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.number }}</p>
                  <p>{{ scope.row.balance }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <!-- ============================== Start change channel popup ========================== -->
    <el-dialog
      :visible.sync="showTradeChannelPopup"
      width="40%"
      center
      custom-class="tradingChannelPop"
    >
      <div v-html="trade_rules_content_top"></div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="agreeTradeRules()"
          style="background: #ff0000; border-color: #ff0000; width: 200px"
          >{{ $t('pc.operate.already_understand') }}
        </el-button>
        <div
          v-html="trade_rules_content_bottom"
          style="padding-top: 10px"
        ></div>
      </span>
    </el-dialog>
    <!-- ============================== end change channel popup ========================== -->
  </div>
</template>

<script>
import $ from "jquery";
import eventBus from "../assets/js/eventBus";

export default {
  name: "stocktrading1",
  data() {
    return {
      handsVolume: '--',
      price_change: 0.001,
      tabsName: "sellStock",
      stockFee:'',
      //股票买入
      stockBuy: {
        info: "",
        marketPrice: "", //市价
        limitPrice: "", //现价
        hardenPrice: 0, //涨停
        dropPrice: 0, //跌停
        number: "",
        code:"",
        buyArr: [
          {
            id: "pc.stocktrading.buy1",
            price: "- -",
            number: "- -",
          },
          // {
          //   id: "买2",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "买3",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "买4",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "买5",
          //   price: "- -",
          //   number: "- -",
          // },
        ], //五档行情
        sellArr: [
          // {
          //   id: "卖5",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "卖4",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "卖3",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "卖2",
          //   price: "- -",
          //   number: "- -",
          // },
          {
            id: "pc.stocktrading.sell1",
            price: "- -",
            number: "- -",
          },
        ],
        validNumber: 0,
      },
      //股票卖出
      stockSell: {
        info: "",
        marketPrice: "", //市价
        limitPrice: "", //现价
        hardenPrice: 0, //涨停
        dropPrice: 0, //跌停
        number: "",
        buyArr: [
          {
            id: "pc.stocktrading.buy1",
            price: "- -",
            number: "- -",
          },
          // {
          //   id: "买2",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "买3",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "买4",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "买5",
          //   price: "- -",
          //   number: "- -",
          // },
        ], //五档行情
        sellArr: [
          // {
          //   id: "卖5",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "卖4",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "卖3",
          //   price: "- -",
          //   number: "- -",
          // },
          // {
          //   id: "卖2",
          //   price: "- -",
          //   number: "- -",
          // },
          {
            id: "pc.stocktrading.sell1",
            price: "- -",
            number: "- -",
          },
        ],
      },
      //撤单
      cancelData: [],
      //持仓
      holdData: [],
      //委托
      entrustData: [],
      //成交
      dealData: [],
      //账户信息
      operateOptions: [],
      //选中账户
      operateData: "",
      //流水资金
      capitalData: [],
      //修改市价限价
      changeBuyType: true,
      changeSellType: true,
      //用户可用余额
      UserAvailable: 0,
      //远程搜索
      loading: false,
      options: [],
      transmitCid: 0,
      unwindData: [],
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      source_return_data: [],
    };
  },
  computed: {
    //下拉框数据
    restaurants: function () {
      return this.$store.state.restaurants;
    },
    //卖出市价计算
    // sellMarketPrice: function () {
    //   let that = this;
    //   let marketPrice = parseInt(
    //     Number(that.UserAvailable) / Number(that.stockSell.marketPrice)
    //   );
    //   if (isNaN(marketPrice)) {
    //     return 0;
    //   } else {
    //     return marketPrice;
    //   }
    // },
     sellMarketPrice: function () {
      let that = this;
      this.totalFee = 0;
      let money = that.UserAvailable;
      let stockqty = money/that.stockSell.marketPrice;
      let change = 0;
      let commission = that.stockFee.sell * stockqty;
      if(commission < 0.99) commission = 0.99;
      let extraFee1 = 0;
      let extraFee2 = (this.stockFee.extra_fee2)*stockqty;
      let extraFee3 = (this.stockFee.extra_fee3)*stockqty;
      if(extraFee3 < 1) extraFee3 = 1;
      let transaction = (this.stockFee.transaction)*stockqty;
      if(transaction < 0.01) transaction = 0.01;
      if(transaction > 9.79) transaction = 9.79;
      let stamp = 0;
      let chj_levy = 0;

      this.totalFee = Number(stamp) + Number(change) + Number(commission) + Number(extraFee1)
      + Number(extraFee2) + Number(extraFee3) + Number(chj_levy) + Number(transaction);
      
      let marketPrice = parseInt((
        Number(that.UserAvailable) - Number(this.totalFee)) / Number(that.stockSell.marketPrice)
      );
      if (isNaN(marketPrice)) {
        return 0;
      } else {
        return marketPrice;
      }
    },
    //卖出限价计算
    sellLimitPrice: function () {
      let that = this;
      let limitPrice = parseInt(
        Number(that.UserAvailable) / Number(that.stockSell.limitPrice)
      );
      if (isNaN(limitPrice) || limitPrice < 0) {
        return 0;
      } else {
        return limitPrice;
      }
    },
  },
  methods: {
    //获取持仓信息
    // settingPriceAmount() {
    //   if ((this.stockBuy.limitPrice * 1000) % (this.price_change * 1000) > 0) {
    //     this.$message.error({
    //       message: "当前股价最小单位为 " + this.price_change,
    //     });
    //   }
    // },
    // settingPriceAmountSell() {
    //   if ((this.stockSell.limitPrice * 1000) % (this.price_change * 1000) > 0) {
    //     this.$message.error({
    //       message: "当前股价最小单位为 " + this.price_change,
    //     });
    //   }
    // },
     getStockFee() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stockfee",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
           that.stockFee = res.data;
        });
    },
    getHoldData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "depot_stock",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 1
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            var dataArr = res.data.data;
            var shortArr = [];
            if (dataArr.length != 0) {
              $.each(dataArr, function (index, item) {
                shortArr.push(item.short);
              });
              that.getNewPrice(shortArr, dataArr);
              clearInterval(window.timer1);
              window.timer1 = setInterval(function () {
                that.getNewPrice(shortArr, dataArr);
              }, 1000);
            } else {
              that.holdData = [];
              clearInterval(window.timer1);
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //请求当前价 计算 盈亏  盈亏比例
    getNewPrice(shortArr, dataArr) {
      let that = this;
      let data = that.getFromShuhai(
        shortArr.toString(),
        true,
        shortArr,
        dataArr
      );
    },
    getFromShuhai(objectElement, return_data = false, shortArr, dataArr) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "shuhai_price",
            code: return_data ? objectElement : objectElement.info.toString(),
            withcode: 0,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (return_data) {
              that.source_return_data = res.data.data;
              that.getShuhaiData(shortArr, dataArr);
              return;
            }

            let elements = res.data.data[0];

            that.stockSell.buyArr[0].price = parseFloat(
              elements["BP1"]
            ).toFixed(3);
            that.stockSell.buyArr[0].number = elements["BV1"];

            that.stockSell.sellArr[0].price = parseFloat(
              elements["SP1"]
            ).toFixed(3);
            that.stockSell.sellArr[0].number = elements["SV1"];

            // $.each(objectElement.buyArr, function (index, item) {
            //   item.price = elements["BP" + (index + 1)];
            //   item.number = elements["BV" + (index + 1)];
            // });
            // $.each(objectElement.sellArr, function (index, item) {
            //   item.price = elements["SP" + (index + 1)];
            //   item.number = elements["SV" + (index + 1)];
            // });
            //that.stockSell.marketPrice = that.stockSell.sellArr[4].price;
            that.stockSell.hardenPrice = "--"; //elements[47];
            that.stockSell.dropPrice = "--"; //elements[48];
          } else if (res.data.code == 0 || res.data.code == -1) {
            //that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    getShuhaiData(shortArr, dataArr) {
      var i, elements;
      let that = this;
      for (i = 0; i < shortArr.length; i++) {
        dataArr[i]["newPrice"] = that.source_return_data[i].NewPrice; //当前价
      }

      for (i = 0; i < shortArr.length; i++) {
        var newPrice = parseFloat(dataArr[i]["newPrice"]); //当前价
        var number = parseFloat(dataArr[i].number); //持有股数
        var costPrice = parseFloat(dataArr[i].price); //成本价
        var costPrice1 = parseFloat(dataArr[i].price1); //成本价
        var profitPrice = Number((costPrice - newPrice).toFixed(2)); //盈亏金额
        var priceRatio = ((costPrice1 - newPrice) / costPrice1) * 100; //盈亏比例
        var market = (newPrice * number).toFixed(2); //当前市值
        let profitMarket = (dataArr[i].surplustotal - newPrice * number).toFixed(
          2
        ); //浮动亏损
        priceRatio = priceRatio.toFixed(2);
        dataArr[i]["profitPrice"] = profitPrice;
        dataArr[i]["priceRatio"] = priceRatio;
        dataArr[i]["market"] = market;
        dataArr[i]["profitMarket"] = profitMarket;
        dataArr[i]["newPrice"] = parseFloat(dataArr[i]["newPrice"]).toFixed(3);
      }
      that.holdData = dataArr;
    },
    //获取全部委托信息
    getEntrustData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "entrust_log",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 1
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let entrustData = res.data.data;
            for (let i = 0, len = entrustData.length; i < len; i++) {
              if (Number(entrustData[i].deal) === 0) {
                entrustData[i].deal = "--";
              }
              if (Number(entrustData[i].price) === 0) {
                entrustData[i].price = "--";
              }
            }
            that.entrustData = entrustData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //获取全部成交订单
    getDealData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "deal_log",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 1
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let dealData = res.data.data;
            let unwindData = [];
            for (let i = 0, len = dealData.length; i < len; i++) {
              if (dealData[i].depot_mold === 1) {
                unwindData.push(dealData[i]);
              }
            }
            that.unwindData = unwindData;
            that.dealData = dealData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //获取全部撤单
    getCancelData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "cancel_order",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 1
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.cancelData = res.data.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //获取账户号
    getOperate() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_operate",
            token: window.sessionStorage.getItem("token"),
            direction: 1
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.operateOptions = res.data.data.filter(item => item.direction_capital!=0);
            if (that.$route.query.cid) {
              that.operateData = parseInt(that.$route.query.cid);
            } else {
              if (that.operateData === "") {
                that.operateData = that.operateOptions[0].cid;
              }
            }

            that.changeOperate();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //获取用户子账户可用余额
    getUserAvailable() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_detailed",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 1
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.UserAvailable = res.data.data.available;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //更改账户
    changeOperate() {
      let that = this;
      that.$route.query.cid = that.operateData;
      that.getHoldData();
      that.getEntrustData();
      that.getDealData();
      that.getCancelData();
      that.getCapitalData();
      that.getUserAvailable();
    },
    //获取资金流水
    getCapitalData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "capital_log",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let capitalData = res.data.data;
            that.capitalData = capitalData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //修改市价限价
    changePrice(deal) {
      let that = this;
      if (deal === "buy") {
        that.changeBuyType
          ? (that.changeBuyType = false)
          : (that.changeBuyType = true);
        that.changeBuyType
          ? ""
          : (that.stockBuy.limitPrice = that.stockBuy.marketPrice);
      } else if (deal === "sell") {
        that.changeSellType
          ? (that.changeSellType = false)
          : (that.changeSellType = true);
        that.changeSellType
          ? ""
          : (that.stockSell.limitPrice = that.stockSell.buyArr[0].price);
      }
    },
    // query_stocks(codeId) {
    //   let that = this;
    //   that
    //     .$http({
    //       url: "/",
    //       method: "post",
    //       data: {
    //         nozzle: "get_stocks",
    //         words: codeId.toUpperCase(),
    //       },
    //     })
    //     .then(function (res) {
    //       if (res.data.code == 1) {
    //         var dataArr = res.data.data;
    //         // that.handsVolume = dataArr[0].hands_volume;
    //         that.price_change = dataArr[0].price_change;
    //       } else if (res.data.code === 0) {
    //         that.$toast.fail(that.$t(res.data.msg));
    //       } else if (res.data.code === -1) {
    //         that.$logout(that.$t(res.data.msg));
    //       }
    //     });
    // },
    //修改股票信息
    //pass optional paramater changeLimitPrice to change the limit price value in the input
    changeInfo(deal, changeLimitPrice = false) {
        let that = this;
        clearInterval(window.timer2);
        clearInterval(window.timer3);
        

      if (deal === "buy"&& that.stockBuy.info !== "") {
      // that.query_stocks(that.stockBuy.info.toString());
      const query = { ...this.$route.query };
      query.symbol = that.stockBuy.info.toString();
      this.$router.replace({ query });

        //that.getFromShuhai(that.stockBuy);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "shuhai_price",
              code: that.stockBuy.info.toString(),
              withcode: 0,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              let elements = res.data.data[0];
              that.stockBuy.buyArr[0].price = parseFloat(
                elements["BP1"]
              ).toFixed(3);
              that.stockBuy.buyArr[0].number = elements["BV1"];

              that.stockBuy.sellArr[0].price = parseFloat(
                elements["SP1"]
              ).toFixed(3);
              that.stockBuy.sellArr[0].number = elements["SV1"];

              // $.each(that.stockBuy.buyArr, function (index, item) {
              //   item.price = elements["BP" + (index + 1)].toFixed(3);
              //   item.number = elements["BV" + (index + 1)];
              // });
              // $.each(that.stockBuy.sellArr, function (index, item) {
              //   item.price = elements["SP" + (index + 1)].toFixed(3);
              //   item.number = elements["SV" + (index + 1)];
              // });
              that.stockBuy.marketPrice = elements["NewPrice"];
              that.stockBuy.hardenPrice = "--"; //elements[47];
              that.stockBuy.dropPrice = "--"; //elements[48];
            } else if (res.data.code == 0 || res.data.code == -1) {
              //that.$message.error(that.$t(res.data.msg));
            }
          });
          let buyable = 0;
        for (let i = 0, len = that.holdData.length; i < len; i++) {
          if (that.holdData[i].short.trim() === that.stockBuy.info.trim()) {
            buyable = that.holdData[i].sellable;
          }
        }
        that.stockBuy.validNumber = buyable;
        clearInterval(window.timer3);
        window.timer3 = setInterval(function () {
          that.changeInfo("buy");
        }, 1000);
      } else if (deal === "sell" && that.stockSell.info !== "") {
      // that.query_stocks(that.stockSell.info.toString());
      const query = { ...this.$route.query };
      query.symbol = that.stockSell.info.toString();
      this.$router.replace({ query });

        //that.getFromShuhai(that.stockSell);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "shuhai_price",
              code: that.stockSell.info.toString(),
              withcode: 0,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              let elements = res.data.data[0];

              that.stockSell.buyArr[0].price = parseFloat(
                elements["BP1"]
              ).toFixed(3);
              that.stockSell.buyArr[0].number = elements["BV1"];

              that.stockSell.sellArr[0].price = parseFloat(
                elements["SP1"]
              ).toFixed(3);
              that.stockSell.sellArr[0].number = elements["SV1"];

              // $.each(that.stockSell.buyArr, function (index, item) {
              //   item.price = parseFloat(elements["BP" + (index + 1)]).toFixed(3);
              //   item.number = elements["BV" + (index + 1)];
              // });
              // $.each(that.stockSell.sellArr, function (index, item) {
              //   item.price = parseFloat(elements["SP" + (index + 1)]).toFixed(3);
              //   item.number = elements["SV" + (index + 1)];
              // });
              that.stockSell.marketPrice = elements["NewPrice"];
              //if (changeLimitPrice)that.stockSell.limitPrice = that.stockSell.buyArr[0].price;
              that.stockSell.hardenPrice = "--"; //elements[47];
              that.stockSell.dropPrice = "--"; //elements[48];
            } else if (res.data.code == 0 || res.data.code == -1) {
              //that.$message.error(that.$t(res.data.msg));
            }
          });

        clearInterval(window.timer2);
        window.timer2 = setInterval(function () {
          that.changeInfo("sell");
        }, 1000);
      }else{
        that.handsVolume="--"
      }
    },
    //快速选仓
    position(storehouse) {
      let that = this;
      switch (storehouse) {
        case "sellFull":
          if (that.changeSellType) {
            that.stockSell.number =
              parseInt( (Number(that.UserAvailable) - Number(this.totalFee)) / Number(that.stockSell.marketPrice));
            // if (that.stockSell.number < that.handsVolume) {
            //   that.stockSell.number = 0;
            // }
          } else {
            that.stockSell.number =
              parseInt( (Number(that.UserAvailable) - Number(this.totalFee)) / Number(that.stockSell.marketPrice));

            // if (that.stockSell.number < that.handsVolume) {
            //   that.stockSell.number = 0;
            // }
          }
          break;
        case "sellThreeFourths":
          if (that.changeSellType) {
            that.stockSell.number =
             parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                      Number(that.stockSell.marketPrice)
                  ) * 0.75
                ) ;

            // if (that.stockSell.number < that.handsVolume) {
            //   that.stockSell.number = 0;
            // }
          } else {
            that.stockSell.number =
              parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                      Number(that.stockSell.marketPrice)
                  ) * 0.75
                ) ;

            // if (that.stockSell.number < that.handsVolume) {
            //   that.stockSell.number = 0;
            // }
          }
          break;
        case "sellTwoFourths":
          if (that.changeSellType) {
            that.stockSell.number =
               parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                      Number(that.stockSell.marketPrice)
                  ) * 0.5
                ) ;

            // if (that.stockSell.number < that.handsVolume) {
            //   that.stockSell.number = 0;
            // }
          } else {
            that.stockSell.number =
               parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                      Number(that.stockSell.marketPrice)
                  ) * 0.5
                ) ;

            // if (that.stockSell.number < that.handsVolume) {
            //   that.stockSell.number = 0;
            // }
          }
          break;
        case "sellOneFourths":
          if (that.changeSellType) {
            that.stockSell.number =
              parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                      Number(that.stockSell.marketPrice)
                  ) * 0.25
                ) ;

            // if (that.stockSell.number < that.handsVolume) {
            //   that.stockSell.number = 0;
            // }
          } else {
            that.stockSell.number =
             parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                      Number(that.stockSell.marketPrice)
                  ) * 0.25
                ) ;
            // if (that.stockSell.number < that.handsVolume) {
            //   that.stockSell.number = 0;
            // }
          }
          break;
        case "buyFull":
          that.stockBuy.number =
            parseInt(that.stockBuy.validNumber) ;
          // if (that.stockBuy.number < that.handsVolume) {
          //   that.stockBuy.number = 0;
          // }
          break;
        case "buyThreeFourths":
          that.stockBuy.number =
           parseInt(that.stockBuy.validNumber * 0.75);
          // if (that.stockBuy.number < that.handsVolume) {
          //   that.stockBuy.number = 0;
          // }
          break;
        case "buyTwoFourths":
          that.stockBuy.number =
            parseInt(that.stockBuy.validNumber * 0.5) ;
          // if (that.stockBuy.number < that.handsVolume) {
          //   that.stockBuy.number = 0;
          // }
          break;
        case "buyOneFourths":
          that.stockBuy.number =
            parseInt(that.stockBuy.validNumber * 0.25) ;
          // if (that.stockBuy.number < that.handsVolume) {
          //   that.stockBuy.number = 0;
          // }
          break;
      }
    },
    remoteMethod(query) {
      let that = this;
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = that.restaurants.filter((item) => {
            return (
              item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.short.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.pinyin.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    //购买股票
    buyStock() {
      let token = window.sessionStorage.getItem("token");
      let that = this;
      let buyPrice = 0;
      let mold = 0;
      if (that.changeBuyType) {
        mold = 2;
        buyPrice = Number(that.stockBuy.marketPrice);
      } else {
        mold = 1;
        buyPrice = Number(that.stockBuy.limitPrice);
      }
      let buyCode =  that.stockBuy.code;
      let buyNumber = parseInt(that.stockBuy.number);
      if (token === null) {
        this.$message.error({
          message: this.$t('pc.trading.you_have_not_logged_in_please_login_before_purchase'),
          onClose: function () {
            that.$router.push({ path: "/login" });
          },
        });
      } else if (buyCode === "") {
        this.$message.error({
          message: this.$t('pc.trading.you_have_not_selected_any_stocks'),
        });
      } 
      // else if (
      //   (this.stockBuy.limitPrice * 1000) % (this.price_change * 1000) >
      //   0
      // ) {
      //   this.$message.error({
      //     message: "当前股价最小单位为 " + this.price_change,
      //   });
      // } 
      else if (buyNumber === "" || isNaN(buyNumber)) {
        this.$message.error({
          message: this.$t('pc.trading.you_have_not_selected_quantity_to_purchase'),
        });
      } else {
        that
          .$confirm(
            // "以" +
            // buyPrice +
            // "元的价格买入" +
            // buyNumber +
            // "股, 是否继续?",
            // "买入股票",
            that.$t('pc.trading.are_you_sure_purchase_this_stock'),
            that.$t('pc.trading.confirm_transaction'),
            {
              confirmButtonText: that.$t('pc.myaccount.confirm'),
              cancelButtonText: that.$t('pc.myaccount.cancel'),
              type: "warning",
            }
          )
          .then(() => {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "buy_stock",
                  token: sessionStorage.getItem("token"),
                  cid: that.operateData,
                  code: buyCode,
                  number: buyNumber,
                  price: buyPrice,
                  mold: mold,
                  direction: 1
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: that.$t(res.data.msg),
                    type: "success",
                    duration: 1000,
                    onClose: function () {
                      that.getOperate();
                      that.stockBuy.number = "";
                    },
                  });
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(that.$t(res.data.msg));
                }
              });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: that.$t('pc.trading.purchase_has_been_cancelled'),
            });
          });
      }
    },
    //卖出股票
    sellStock() {
      let that = this;
      let token = window.sessionStorage.getItem("token");
      let sellPrice = 0;
      let mold = 0;
      if (that.changeSellType) {
        mold = 2;
        sellPrice = Number(that.stockSell.marketPrice);
      } else {
        mold = 1;
        sellPrice = Number(that.stockSell.limitPrice);
      }
      let sellCode = that.options.find((i) => i.short == that.stockSell.info).code;
      console.log("sellc",sellCode);
      let sellNumber = parseInt(that.stockSell.number);

      if (token === null) {
        this.$message.error({
          message: this.$t('pc.trading.you_have_not_logged_in_please_login_before_sale'),
          onClose: function () {
            that.$router.push({ path: "/login" });
          },
        });
      } else if (sellCode === "") {
        this.$message.error({
          message: this.$t('pc.trading.you_have_not_selected_any_stocks'),
        });
      } 
      // else if (
      //   (this.stockSell.limitPrice * 1000) % (this.price_change * 1000) >
      //   0
      // ) {
      //   this.$message.error({
      //     message: "当前股价最小单位为 " + this.price_change,
      //   });
      // } 
      else if (sellNumber === "" || isNaN(sellNumber)) {
        this.$message.error({
          message: this.$t('pc.trading.you_have_not_selected_quantity_for_sale'),
        });
      } else {
        that
          .$confirm(
            // "以" +
            // sellPrice +
            // "的价格卖出" +
            // sellNumber +
            // "股, 是否继续?",
            // "卖出股票",
            that.$t('pc.trading.are_you_sure_sell_this_stock'),
            that.$t('pc.trading.confirm_transaction'),
            {
              confirmButtonText: that.$t('pc.myaccount.confirm'),
              cancelButtonText: that.$t('pc.myaccount.cancel'),
              type: "warning",
            }
          )
          .then(() => {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sell_stock",
                  token: sessionStorage.getItem("token"),
                  cid: that.operateData,
                  code: sellCode,
                  number: sellNumber,
                  price: sellPrice,
                  mold: mold,
                  direction: 1
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: that.$t(res.data.msg),
                    type: "success",
                    duration: 1000,
                    onClose: function () {
                      that.getOperate();
                      that.stockSell.number = "";
                    },
                  });
                  /*that.$refs.child1.getStrategyInfo();
                      setTimeout(function() {
                        that.setNumber(that.maxNumber, that.ratio);
                        that.getHoldlist();
                        that.getInfo(that.short, 1);
                      }, 1000);*/
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(that.$t(res.data.msg));
                }
              });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: that.$t('pc.trading.sale_and_puchase_cancelled'),
            });
          });
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
          }
        });
    },
    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$message({
              message: that.$t(res.data.msg),
              type: "success",
              duration: 1000,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //点击表格触发赋值
    buyHanddle(row, event, column) {
      let that = this;
      that.stockBuy.info = row.short;
      that.stockBuy.validNumber = row.sellable;
        that.stockBuy.code=row.code;
      that.changeInfo("buy", true);
      that.remoteMethod(row.short);
    },
    //点击卖出表格触发
    sellHanddle(row, event, column) {
      console.log(row);
      let that = this;
      that.stockSell.info = row.short;
      that.changeInfo("sell", true);
      that.remoteMethod(row.short);
    },
    //持仓页面进入买入页面
    holdBuy(short,code) {
      let that = this;
      that.stockBuy.info = short;
      that.stockBuy.code = code;
      that.changeInfo("buy", true);
      that.remoteMethod(short);
      this.tabsName = "buyStock";
    },
    //持仓页面进入卖出页面
    holdSell(short,code) {
      let that = this;
      that.stockSell.info = short;
      that.stockSell.code = code;
      that.changeInfo("sell", true);
      that.remoteMethod(short);
      this.tabsName = "sellStock";
    },
    //持仓页面进入行情页面
    marketGo(short) {
      let that = this;
      that.$router.push({ path: "/stockdetailed?symbol=" + short + "&direction=1" });
    },
    //撤单
    handleCance(data) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "cancel_entrust",
            token: sessionStorage.getItem("token"),
            cid: that.operateData,
            order: data.id
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$message({
              message: that.$t(res.data.msg),
              type: "success",
              duration: 1000,
              onClose: function () {
                that.changeOperate();
              },
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    //时间格式数据
    timeTypeData(value) {
      let temp = [];
      for (let i = 0, len = value.length; i < len; i++) {
        if (!temp.includes(value[i].time)) {
          temp.push(value[i].time);
        }
      }
      for (let i = 0, len = temp.length; i < len; i++) {
        temp[i] = { index: i + 1, time: temp[i], children: [] };
        for (let j = 0, len1 = value.length; j < len1; j++) {
          if (temp[i].time === value[j].time) {
            value[j].index = parseInt((i + 1).toString() + (j + 1).toString());
            temp[i].children.push(value[j]);
          }
        }
      }
      return temp;
    },
    handleClick(tab, event) {
      let that = this;
      if(tab.name === "sellStock"){
        this.changeInfo("sell");
      }      if(tab.name === "buyStock"){
        this.changeInfo("buy");
      }
      if (tab.name == "canceStock") {
        that.changeOperate();
      }
    },
  },
  mounted: function () {
    if (this.$store.state.loginType) {
      this.getOperate();
      this.getStockFee();
    }
  },
  watch: {
    "stockBuy.limitPrice": {
      handler: function (value) {
        let that = this;
        var str = value;
        var len1 = str.substr(0, 1);
        var len2 = str.substr(1, 1);
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
        }
        //第一位不能是.
        if (len1 == ".") {
          str = "";
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);
          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }
        }
        if (str.length > 10) {
          str = str.substring(0, 10);
        }

        //正则替换，保留数字和小数点
        // str = str.replace(/[^\d^\.]+/g,'');
        //如果需要保留小数点后两位，则用下面公式
        // str = str.replace(/\.\d\d\d$/, "");
        that.stockBuy.limitPrice = str;
      },
    },
    "stockSell.limitPrice": {
      handler: function (value) {
        let that = this;
        var str = value;
        var len1 = str.substr(0, 1);
        var len2 = str.substr(1, 1);
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
        }
        //第一位不能是.
        if (len1 == ".") {
          str = "";
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);
          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }
        }
        if (str.length > 10) {
          str = str.substring(0, 10);
        }
        //正则替换，保留数字和小数点
        // str = str.replace(/[^\d^\.]+/g,'');
        //如果需要保留小数点后两位，则用下面公式
        // str = str.replace(/\.\d\d\d$/, "");
        that.stockSell.limitPrice = str;
      },
    },
  },
  created() {
    let that = this;
    eventBus.$on("symbol", (symbol) => {
      that.holdSell(symbol);
    });
  },
  beforeDestroy() {
    clearTimeout(window.timer1);
    clearTimeout(window.timer2);
    clearTimeout(window.timer3);
  },
};
</script>
<style scoped>
.extra-mini-btn {
  font-size: 12px !important;   /* smaller text */
  padding: 1px 4px !important;  /* tighter padding */
  height: 30px !important;      /* reduce button height */
  line-height: 18px !important; /* align text */
}
.submit {
  width: 100%;
}
.green {
  color: #008000;
}
.full_width {
  width: 100%;
}
.box-market {
  overflow: hidden;
  font-size: 14px;
  line-height: 1.5;
}
.container {
  width: 100%;
  max-width: 1200px;
  min-width: 1400px;
  margin: 10px auto;
}
.button_green_color, .button_green_color:hover{
  border:#3f7a21 !important ;
  background-color:#3f7a21 !important;
}
.blue {
  color: #7f95ee !important ;
}
.button_blue_color, .button_blue_color:hover{
  border:#0D268D !important ;
  background-color:#0D268D !important;
}
</style>
<style>
.tradingChannelPop .el-dialog__body {
  padding: 0px 20px;
}

/* .tradingChannelPop .el-dialog__header {
  display: none;
} */
#cardPadding .el-card__body {
    padding: 15px 0px;
}

#cardPaddingSell .el-card__body {
    padding: 15px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/stocktrading1.vue